import { z } from "zod";
import type { ElementSummary, PageContext } from "./index";

export const ScreenshotRegionSchema = z.object({
  x: z.number().finite().min(0).max(1),
  y: z.number().finite().min(0).max(1),
  width: z.number().finite().positive().max(1),
  height: z.number().finite().positive().max(1),
}).strict().refine(value => value.x + value.width <= 1 + 1e-9 && value.y + value.height <= 1 + 1e-9, "选区必须位于当前视口内");
export type ScreenshotRegion = z.infer<typeof ScreenshotRegionSchema>;

/** Only fully visible, bounded native controls can be proposed for filling. */
export function screenshotRegionContext(context: PageContext, input: ScreenshotRegion, imageCoordinates = false): PageContext {
  const region = ScreenshotRegionSchema.parse(input);
  const field = (value: ElementSummary): ElementSummary[] => {
    const bounds = value.viewportBounds;
    if (!bounds || !["input", "textarea", "select"].includes(value.tag.toLowerCase())
      || !Object.values(bounds).every(Number.isFinite)
      || bounds.x < region.x || bounds.y < region.y
      || bounds.x + bounds.width > region.x + region.width + 1e-9
      || bounds.y + bounds.height > region.y + region.height + 1e-9) return [];
    return [{ ...value, nearbyText: undefined, viewportBounds: imageCoordinates ? {
      x: (bounds.x - region.x) / region.width, y: (bounds.y - region.y) / region.height,
      width: bounds.width / region.width, height: bounds.height / region.height,
    } : bounds }];
  };
  const forms = context.forms?.map(form => ({ ...form, fields: form.fields.flatMap(field) })).filter(form => form.fields.length);
  const interactiveElements = context.interactiveElements.flatMap(field);
  const all = [...(forms?.flatMap(form => form.fields) || []), ...interactiveElements];
  return { ...context, forms, interactiveElements, products: [],
    selectedElement: context.selectedElement ? field(context.selectedElement)[0] : undefined,
    visibleText: ["本轮仅分析用户框选区域。框外内容未知；控件不完整或没有对应真实输入框时需重新框选。", ...new Set(all.map(value => value.label || value.text || value.placeholder || value.elementId))].join("\n").slice(0, 16000),
  };
}
